import * as React from "react";
import ModelContainer from "../../../components/model/ModelContainer";
import PageTitle from "../../../components/model/PageTitle";
import ModelTitle from "../../../components/model/ModelTitle";
import ModelInfo from "../../../components/model/ModelInfo";
import {GAEventModels} from "../../../utils/SendGAEvent";
import ModelDescription from "../../../components/model/ModelDescription";
import SocialSentimentModel from "./SocialSentimentModel";
import Disclaimer from "../../../components/model/Disclaimer";
import TabPanel from "../../../components/model/TabPanel";

const SocialSentiment = () => {
    return <ModelContainer>
        <PageTitle/>
        <div>
            <ModelTitle>Social Sentiment</ModelTitle>
            <ModelInfo model={GAEventModels.SOCIAL_SENTIMENT}/>
            <TabPanel
                modelName={GAEventModels.SOCIAL_SENTIMENT}
                modelDescription={<ModelDescription>This model outputs different scores regarding particular Stock. A score is a custom calculation we apply to every social media post our systems analyze. It provides a numerical value which encompasses both the sentiment of a post and its popularity. A post speaking positively about a company and with many likes and shares will have a high sentiment score. A post reflecting poorly of a company but with few likes will have a small negative sentiment score. A post we consider neutral will have a near zero score regardless of popularity.</ModelDescription>}
                content={<SocialSentimentModel/>}
            />
            <Disclaimer/>
        </div>
    </ModelContainer>;
};

export default SocialSentiment;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/SocialSentiment/index.tsx